module.exports = __webpack_public_path__ + "static/media/logo-cinza.11d0f7aa.png";